import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useAdminService } from '~/services';
import { moment, momentFormats } from '~/vendorConfigs/moment';

interface ActiveToggleProps {
    user: UserType;
    setServerError: (e: { message: string }) => void;
}
export function ActiveToggle({ user, setServerError }: ActiveToggleProps) {
    const { updateUser } = useAdminService();
    const [loading, setLoading] = React.useState(false);

    async function toggleUserActive() {
        try {
            setLoading(true);
            await updateUser(
                user.id,
                {
                    enabled_at: user.enabled_at
                        ? null
                        : moment().format(momentFormats.LR_API_DATETIME),
                },
                { handledErrors: { 400: true } }
            );
            setLoading(false);
        } catch (e) {
            setLoading(false);
            setServerError(e);
        }
    }

    return (
        <button className="link-button" type="button" onClick={toggleUserActive} disabled={loading}>
            {user.enabled_at ? 'Disable' : 'Reactivate'} User
            {loading && <Spinner animation="border" role="status" size="sm" className="ms-1" />}
        </button>
    );
}
